import { utcToDate } from "../../../../core/helpers/date-util.js";
import Model from "../../../Model.js";
import UserReference from "../../../UserReference.js";

/**
 * `AbstractPeriodReportEvent` represents a recorded incident in period report's lifecycle.
 * There can be status events (i.e., events describing the state of the period report)
 * such as `CreateEvent`, `PublishEvent`, and `WithdrawEvent`; as well as non status
 * event (i.e., events happening to a published report) such as `NotifyEvent` or
 * `ViewEvent`.
 *
 * @param {string} spec.type - type of event
 * @param {datetime} spec.timestamp - the time this event occurred
 * @param {userReference} spec.author - reference information describing the author of the event in question
 */
export default class AbstractPeriodReportEvent extends Model {
	constructor(spec) {
		super(...arguments);
		this._type = spec.type;
		this._timestamp = spec.timestamp;
		this._author = spec.author;
	}

	getType() {
		return this._type;
	}

	getTimestamp() {
		return this._timestamp;
	}

	getAuthor() {
		return this._author;
	}

	getLabel() {
		return this.getType();
	}

	isStatusEvent() {
		return false;
	}

	isPublish() {
		return false;
	}

	isWithdraw() {
		return false;
	}

	isCreate() {
		return false;
	}

	isView() {
		return false;
	}

	isAcknowledged() {
		return false;
	}

	isAcknowledgeBy(_user) {
		return false;
	}

	isViewedByCompanyUser() {
		return false;
	}

	static transformMaterializationData(data) {
		data.timestamp &&= utcToDate(data.timestamp);
		data.author = UserReference.materialize(data.author);
	}
}
